"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriftSnackbar = void 0;
const react_1 = __importDefault(require("react"));
const styles_1 = require("@mui/material/styles");
const Icons_1 = require("../icon/Icons");
const Snackbar_1 = require("./Snackbar");
const SnackbarContent_1 = require("../snackbarContent/SnackbarContent");
const Button_1 = require("../button/Button");
const IconButton_1 = require("../button/IconButton");
const driftSnackbarClasses = {
    root: 'DriftSnackbar-root',
    button: 'DriftSnackbar-button',
    closeIcon: 'DriftSnackbar-closeIcon',
};
const getBorderColorForVariant = (theme, variant) => {
    const COLOR_VARIANTS = {
        primary: theme.palette.blue[500],
        error: theme.palette.red[500],
        success: theme.palette.green[500],
        warning: theme.palette.yellow[500],
    };
    return COLOR_VARIANTS[variant];
};
const ActionButton = ({ label, onClick, onCloseButtonClick }) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(Button_1.Button, { variant: "text", size: "small", onClick: onClick, classes: { root: driftSnackbarClasses.button } }, label),
    onCloseButtonClick && (react_1.default.createElement(IconButton_1.IconButton, { onClick: onCloseButtonClick, size: "small", classes: { root: driftSnackbarClasses.closeIcon } },
        react_1.default.createElement(Icons_1.CloseIcon, { fontSize: "small" })))));
const DriftSnackbar = (0, styles_1.styled)((_a) => {
    var { button } = _a, props = __rest(_a, ["button"]);
    return (react_1.default.createElement(Snackbar_1.Snackbar, Object.assign({}, props, { classes: { root: driftSnackbarClasses.root }, action: button ? react_1.default.createElement(ActionButton, Object.assign({}, button)) : null })));
})(({ theme, variant }) => ({
    [`&.${driftSnackbarClasses.root}`]: {
        borderLeftWidth: `${variant ? '4px' : '0'}`,
        borderLeftStyle: 'solid',
        borderLeftColor: `${variant ? getBorderColorForVariant(theme, variant) : theme.palette.common.black}`,
        height: 'auto',
        minHeight: '42px',
        [`.${SnackbarContent_1.snackbarContentClasses.action}`]: {
            marginRight: 0,
        },
        [`.${driftSnackbarClasses.button}`]: {
            color: theme.palette.blue[300],
            padding: '8px 12px',
            borderRadius: '4px',
            minWidth: 'unset',
            fontSize: '0.875rem',
            '&:hover': {
                backgroundColor: 'transparent',
                textDecoration: 'underline',
            },
        },
        [`.${driftSnackbarClasses.closeIcon}`]: {
            padding: '2px',
            marginLeft: '8px',
            color: theme.palette.common.white,
        },
    },
}));
exports.DriftSnackbar = DriftSnackbar;
//# sourceMappingURL=DriftSnackbar.js.map